/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarPlan,
  HangarPlanAcquisitionCreateInput,
  HangarPlanAcquisitionUpdateInput,
  HangarPlanCandidateCreateInput,
  HangarPlanCandidateUpdateInput,
  HangarPlanCompare,
  HangarPlanComparison,
  HangarPlanCreateInput,
  HangarPlanDrift,
  HangarPlanKeepCreateInput,
  HangarPlanMeltCreateInput,
  HangarPlanMeltUpdateInput,
  HangarPlanResources,
  HangarPlanSlotChooseInput,
  HangarPlanSlotCreateInput,
  HangarPlanSlotSortInput,
  HangarPlanSlotUpdateInput,
  HangarPlanSuggestions,
  HangarPlanSummary,
  HangarPlanUpdateInput,
  HangarPlanVehicleMarkCreateInput,
  HangarPlanVehicleMarkUpdateInput,
  HangarPlanWishlistResult,
  HangarPlansList,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Hangar Plans
 */
export const hangarPlans = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarPlansList>(
      {url: `/hangar/plans`, method: 'GET', signal
    },
      );
    }




export const getHangarPlansQueryKey = () => {
    return [
    'hangar','plans'
    ] as const;
    }


export const getHangarPlansQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlans>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlans>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlans>>> = ({ signal }) => hangarPlans(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlans>>, TError, TData>
}

export type HangarPlansQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlans>>>
export type HangarPlansQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Plans
 */

export function useHangarPlans<TData = Awaited<ReturnType<typeof hangarPlans>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Hangar Plan
 */
export const createHangarPlan = (
    hangarPlanCreateInput: MaybeRefOrGetter<HangarPlanCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanCreateInput = toValue(hangarPlanCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanMutationKey = () => ['createHangarPlan'] as const;

export const getCreateHangarPlanMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlan>>, TError,CreateHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlan>>, TError,CreateHangarPlanMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlan>>, CreateHangarPlanMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createHangarPlan(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlan>>>
    export type CreateHangarPlanMutationBody = HangarPlanCreateInput
    export type CreateHangarPlanMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarPlanMutationVariables = {data: HangarPlanCreateInput}

    /**
 * @summary Create Hangar Plan
 */
export const useCreateHangarPlan = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlan>>, TError,CreateHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlan>>,
        TError,
        CreateHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Hangar Plan Acquisition
 */
export const createHangarPlanAcquisition = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanAcquisitionCreateInput: MaybeRefOrGetter<HangarPlanAcquisitionCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanAcquisitionCreateInput = toValue(hangarPlanAcquisitionCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/acquisitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanAcquisitionCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanAcquisitionMutationKey = () => ['createHangarPlanAcquisition'] as const;

export const getCreateHangarPlanAcquisitionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanAcquisition>>, TError,CreateHangarPlanAcquisitionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanAcquisition>>, TError,CreateHangarPlanAcquisitionMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanAcquisitionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanAcquisition>>, CreateHangarPlanAcquisitionMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanAcquisition(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanAcquisitionMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanAcquisition>>>
    export type CreateHangarPlanAcquisitionMutationBody = HangarPlanAcquisitionCreateInput
    export type CreateHangarPlanAcquisitionMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarPlanAcquisitionMutationVariables = {hangarPlanId: string;data: HangarPlanAcquisitionCreateInput}

    /**
 * @summary Create Hangar Plan Acquisition
 */
export const useCreateHangarPlanAcquisition = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanAcquisition>>, TError,CreateHangarPlanAcquisitionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanAcquisition>>,
        TError,
        CreateHangarPlanAcquisitionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanAcquisitionMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Plan Acquisition
 */
export const updateHangarPlanAcquisition = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanAcquisitionUpdateInput: MaybeRefOrGetter<HangarPlanAcquisitionUpdateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanAcquisitionUpdateInput = toValue(hangarPlanAcquisitionUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/acquisitions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanAcquisitionUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanAcquisitionMutationKey = () => ['updateHangarPlanAcquisition'] as const;

export const getUpdateHangarPlanAcquisitionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanAcquisition>>, TError,UpdateHangarPlanAcquisitionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanAcquisition>>, TError,UpdateHangarPlanAcquisitionMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanAcquisitionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlanAcquisition>>, UpdateHangarPlanAcquisitionMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  updateHangarPlanAcquisition(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanAcquisitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlanAcquisition>>>
    export type UpdateHangarPlanAcquisitionMutationBody = HangarPlanAcquisitionUpdateInput
    export type UpdateHangarPlanAcquisitionMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateHangarPlanAcquisitionMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanAcquisitionUpdateInput}

    /**
 * @summary Update Hangar Plan Acquisition
 */
export const useUpdateHangarPlanAcquisition = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanAcquisition>>, TError,UpdateHangarPlanAcquisitionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlanAcquisition>>,
        TError,
        UpdateHangarPlanAcquisitionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanAcquisitionMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan Acquisition
 */
export const destroyHangarPlanAcquisition = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/acquisitions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanAcquisitionMutationKey = () => ['destroyHangarPlanAcquisition'] as const;

export const getDestroyHangarPlanAcquisitionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>, TError,DestroyHangarPlanAcquisitionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>, TError,DestroyHangarPlanAcquisitionMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanAcquisitionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>, DestroyHangarPlanAcquisitionMutationVariables> = (props) => {
          const {hangarPlanId,id} = props ?? {};

          return  destroyHangarPlanAcquisition(hangarPlanId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanAcquisitionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>>

    export type DestroyHangarPlanAcquisitionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanAcquisitionMutationVariables = {hangarPlanId: string;id: string}

    /**
 * @summary Destroy Hangar Plan Acquisition
 */
export const useDestroyHangarPlanAcquisition = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>, TError,DestroyHangarPlanAcquisitionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlanAcquisition>>,
        TError,
        DestroyHangarPlanAcquisitionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanAcquisitionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Hangar Plan Candidate
 */
export const createHangarPlanCandidate = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanCandidateCreateInput: MaybeRefOrGetter<HangarPlanCandidateCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanCandidateCreateInput = toValue(hangarPlanCandidateCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/candidates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanCandidateCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanCandidateMutationKey = () => ['createHangarPlanCandidate'] as const;

export const getCreateHangarPlanCandidateMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanCandidate>>, TError,CreateHangarPlanCandidateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanCandidate>>, TError,CreateHangarPlanCandidateMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanCandidateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanCandidate>>, CreateHangarPlanCandidateMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanCandidate(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanCandidate>>>
    export type CreateHangarPlanCandidateMutationBody = HangarPlanCandidateCreateInput
    export type CreateHangarPlanCandidateMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarPlanCandidateMutationVariables = {hangarPlanId: string;data: HangarPlanCandidateCreateInput}

    /**
 * @summary Create Hangar Plan Candidate
 */
export const useCreateHangarPlanCandidate = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanCandidate>>, TError,CreateHangarPlanCandidateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanCandidate>>,
        TError,
        CreateHangarPlanCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanCandidateMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Plan Candidate
 */
export const updateHangarPlanCandidate = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanCandidateUpdateInput: MaybeRefOrGetter<HangarPlanCandidateUpdateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanCandidateUpdateInput = toValue(hangarPlanCandidateUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/candidates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanCandidateUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanCandidateMutationKey = () => ['updateHangarPlanCandidate'] as const;

export const getUpdateHangarPlanCandidateMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanCandidate>>, TError,UpdateHangarPlanCandidateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanCandidate>>, TError,UpdateHangarPlanCandidateMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanCandidateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlanCandidate>>, UpdateHangarPlanCandidateMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  updateHangarPlanCandidate(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlanCandidate>>>
    export type UpdateHangarPlanCandidateMutationBody = HangarPlanCandidateUpdateInput
    export type UpdateHangarPlanCandidateMutationError = ErrorType<ValidationError>
    export type UpdateHangarPlanCandidateMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanCandidateUpdateInput}

    /**
 * @summary Update Hangar Plan Candidate
 */
export const useUpdateHangarPlanCandidate = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanCandidate>>, TError,UpdateHangarPlanCandidateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlanCandidate>>,
        TError,
        UpdateHangarPlanCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanCandidateMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan Candidate
 */
export const destroyHangarPlanCandidate = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/candidates/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanCandidateMutationKey = () => ['destroyHangarPlanCandidate'] as const;

export const getDestroyHangarPlanCandidateMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanCandidate>>, TError,DestroyHangarPlanCandidateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanCandidate>>, TError,DestroyHangarPlanCandidateMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanCandidateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlanCandidate>>, DestroyHangarPlanCandidateMutationVariables> = (props) => {
          const {hangarPlanId,id} = props ?? {};

          return  destroyHangarPlanCandidate(hangarPlanId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlanCandidate>>>

    export type DestroyHangarPlanCandidateMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanCandidateMutationVariables = {hangarPlanId: string;id: string}

    /**
 * @summary Destroy Hangar Plan Candidate
 */
export const useDestroyHangarPlanCandidate = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanCandidate>>, TError,DestroyHangarPlanCandidateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlanCandidate>>,
        TError,
        DestroyHangarPlanCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanCandidateMutationOptions(options), queryClient);
    }
    /**
 * @summary Keep Hangar Plan Vehicles
 */
export const createHangarPlanKeep = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanKeepCreateInput: MaybeRefOrGetter<HangarPlanKeepCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanKeepCreateInput = toValue(hangarPlanKeepCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/keeps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanKeepCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanKeepMutationKey = () => ['createHangarPlanKeep'] as const;

export const getCreateHangarPlanKeepMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanKeep>>, TError,CreateHangarPlanKeepMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanKeep>>, TError,CreateHangarPlanKeepMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanKeepMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanKeep>>, CreateHangarPlanKeepMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanKeep(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanKeepMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanKeep>>>
    export type CreateHangarPlanKeepMutationBody = HangarPlanKeepCreateInput
    export type CreateHangarPlanKeepMutationError = ErrorType<ValidationError>
    export type CreateHangarPlanKeepMutationVariables = {hangarPlanId: string;data: HangarPlanKeepCreateInput}

    /**
 * @summary Keep Hangar Plan Vehicles
 */
export const useCreateHangarPlanKeep = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanKeep>>, TError,CreateHangarPlanKeepMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanKeep>>,
        TError,
        CreateHangarPlanKeepMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanKeepMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Hangar Plan Melt
 */
export const createHangarPlanMelt = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanMeltCreateInput: MaybeRefOrGetter<HangarPlanMeltCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanMeltCreateInput = toValue(hangarPlanMeltCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/melts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanMeltCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanMeltMutationKey = () => ['createHangarPlanMelt'] as const;

export const getCreateHangarPlanMeltMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanMelt>>, TError,CreateHangarPlanMeltMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanMelt>>, TError,CreateHangarPlanMeltMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanMeltMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanMelt>>, CreateHangarPlanMeltMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanMelt(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanMeltMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanMelt>>>
    export type CreateHangarPlanMeltMutationBody = HangarPlanMeltCreateInput
    export type CreateHangarPlanMeltMutationError = ErrorType<ValidationError>
    export type CreateHangarPlanMeltMutationVariables = {hangarPlanId: string;data: HangarPlanMeltCreateInput}

    /**
 * @summary Create Hangar Plan Melt
 */
export const useCreateHangarPlanMelt = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanMelt>>, TError,CreateHangarPlanMeltMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanMelt>>,
        TError,
        CreateHangarPlanMeltMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanMeltMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Plan Melt
 */
export const updateHangarPlanMelt = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanMeltUpdateInput: MaybeRefOrGetter<HangarPlanMeltUpdateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanMeltUpdateInput = toValue(hangarPlanMeltUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/melts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanMeltUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanMeltMutationKey = () => ['updateHangarPlanMelt'] as const;

export const getUpdateHangarPlanMeltMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanMelt>>, TError,UpdateHangarPlanMeltMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanMelt>>, TError,UpdateHangarPlanMeltMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanMeltMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlanMelt>>, UpdateHangarPlanMeltMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  updateHangarPlanMelt(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanMeltMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlanMelt>>>
    export type UpdateHangarPlanMeltMutationBody = HangarPlanMeltUpdateInput
    export type UpdateHangarPlanMeltMutationError = ErrorType<ValidationError>
    export type UpdateHangarPlanMeltMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanMeltUpdateInput}

    /**
 * @summary Update Hangar Plan Melt
 */
export const useUpdateHangarPlanMelt = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanMelt>>, TError,UpdateHangarPlanMeltMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlanMelt>>,
        TError,
        UpdateHangarPlanMeltMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanMeltMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan Melt
 */
export const destroyHangarPlanMelt = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/melts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanMeltMutationKey = () => ['destroyHangarPlanMelt'] as const;

export const getDestroyHangarPlanMeltMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanMelt>>, TError,DestroyHangarPlanMeltMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanMelt>>, TError,DestroyHangarPlanMeltMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanMeltMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlanMelt>>, DestroyHangarPlanMeltMutationVariables> = (props) => {
          const {hangarPlanId,id} = props ?? {};

          return  destroyHangarPlanMelt(hangarPlanId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanMeltMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlanMelt>>>

    export type DestroyHangarPlanMeltMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanMeltMutationVariables = {hangarPlanId: string;id: string}

    /**
 * @summary Destroy Hangar Plan Melt
 */
export const useDestroyHangarPlanMelt = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanMelt>>, TError,DestroyHangarPlanMeltMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlanMelt>>,
        TError,
        DestroyHangarPlanMeltMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanMeltMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Hangar Plan Slot
 */
export const createHangarPlanSlot = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanSlotCreateInput: MaybeRefOrGetter<HangarPlanSlotCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanSlotCreateInput = toValue(hangarPlanSlotCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanSlotCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanSlotMutationKey = () => ['createHangarPlanSlot'] as const;

export const getCreateHangarPlanSlotMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanSlot>>, TError,CreateHangarPlanSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanSlot>>, TError,CreateHangarPlanSlotMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanSlot>>, CreateHangarPlanSlotMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanSlot(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanSlot>>>
    export type CreateHangarPlanSlotMutationBody = HangarPlanSlotCreateInput
    export type CreateHangarPlanSlotMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarPlanSlotMutationVariables = {hangarPlanId: string;data: HangarPlanSlotCreateInput}

    /**
 * @summary Create Hangar Plan Slot
 */
export const useCreateHangarPlanSlot = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanSlot>>, TError,CreateHangarPlanSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanSlot>>,
        TError,
        CreateHangarPlanSlotMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort Hangar Plan Slots
 */
export const sortHangarPlanSlots = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanSlotSortInput: MaybeRefOrGetter<HangarPlanSlotSortInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanSlotSortInput = toValue(hangarPlanSlotSortInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/slots/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanSlotSortInput, signal
    },
      );
    }




export const getSortHangarPlanSlotsMutationKey = () => ['sortHangarPlanSlots'] as const;

export const getSortHangarPlanSlotsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortHangarPlanSlots>>, TError,SortHangarPlanSlotsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortHangarPlanSlots>>, TError,SortHangarPlanSlotsMutationVariables, TContext> => {

const mutationKey = getSortHangarPlanSlotsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortHangarPlanSlots>>, SortHangarPlanSlotsMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  sortHangarPlanSlots(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortHangarPlanSlotsMutationResult = NonNullable<Awaited<ReturnType<typeof sortHangarPlanSlots>>>
    export type SortHangarPlanSlotsMutationBody = HangarPlanSlotSortInput
    export type SortHangarPlanSlotsMutationError = ErrorType<SchemaValidationErrorResponse>
    export type SortHangarPlanSlotsMutationVariables = {hangarPlanId: string;data: HangarPlanSlotSortInput}

    /**
 * @summary Sort Hangar Plan Slots
 */
export const useSortHangarPlanSlots = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortHangarPlanSlots>>, TError,SortHangarPlanSlotsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortHangarPlanSlots>>,
        TError,
        SortHangarPlanSlotsMutationVariables,
        TContext
      > => {
      return useMutation(getSortHangarPlanSlotsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Plan Slot
 */
export const updateHangarPlanSlot = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanSlotUpdateInput: MaybeRefOrGetter<HangarPlanSlotUpdateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanSlotUpdateInput = toValue(hangarPlanSlotUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/slots/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanSlotUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanSlotMutationKey = () => ['updateHangarPlanSlot'] as const;

export const getUpdateHangarPlanSlotMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanSlot>>, TError,UpdateHangarPlanSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanSlot>>, TError,UpdateHangarPlanSlotMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlanSlot>>, UpdateHangarPlanSlotMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  updateHangarPlanSlot(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlanSlot>>>
    export type UpdateHangarPlanSlotMutationBody = HangarPlanSlotUpdateInput
    export type UpdateHangarPlanSlotMutationError = ErrorType<ValidationError>
    export type UpdateHangarPlanSlotMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanSlotUpdateInput}

    /**
 * @summary Update Hangar Plan Slot
 */
export const useUpdateHangarPlanSlot = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanSlot>>, TError,UpdateHangarPlanSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlanSlot>>,
        TError,
        UpdateHangarPlanSlotMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan Slot
 */
export const destroyHangarPlanSlot = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/slots/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanSlotMutationKey = () => ['destroyHangarPlanSlot'] as const;

export const getDestroyHangarPlanSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanSlot>>, TError,DestroyHangarPlanSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanSlot>>, TError,DestroyHangarPlanSlotMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlanSlot>>, DestroyHangarPlanSlotMutationVariables> = (props) => {
          const {hangarPlanId,id} = props ?? {};

          return  destroyHangarPlanSlot(hangarPlanId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanSlotMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlanSlot>>>

    export type DestroyHangarPlanSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanSlotMutationVariables = {hangarPlanId: string;id: string}

    /**
 * @summary Destroy Hangar Plan Slot
 */
export const useDestroyHangarPlanSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanSlot>>, TError,DestroyHangarPlanSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlanSlot>>,
        TError,
        DestroyHangarPlanSlotMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Choose Hangar Plan Slot Candidate
 */
export const chooseHangarPlanSlotCandidate = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanSlotChooseInput: MaybeRefOrGetter<HangarPlanSlotChooseInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanSlotChooseInput = toValue(hangarPlanSlotChooseInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/slots/${id}/choose`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanSlotChooseInput, signal
    },
      );
    }




export const getChooseHangarPlanSlotCandidateMutationKey = () => ['chooseHangarPlanSlotCandidate'] as const;

export const getChooseHangarPlanSlotCandidateMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>, TError,ChooseHangarPlanSlotCandidateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>, TError,ChooseHangarPlanSlotCandidateMutationVariables, TContext> => {

const mutationKey = getChooseHangarPlanSlotCandidateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>, ChooseHangarPlanSlotCandidateMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  chooseHangarPlanSlotCandidate(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChooseHangarPlanSlotCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>>
    export type ChooseHangarPlanSlotCandidateMutationBody = HangarPlanSlotChooseInput
    export type ChooseHangarPlanSlotCandidateMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ChooseHangarPlanSlotCandidateMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanSlotChooseInput}

    /**
 * @summary Choose Hangar Plan Slot Candidate
 */
export const useChooseHangarPlanSlotCandidate = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>, TError,ChooseHangarPlanSlotCandidateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof chooseHangarPlanSlotCandidate>>,
        TError,
        ChooseHangarPlanSlotCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getChooseHangarPlanSlotCandidateMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Hangar Plan Vehicle Mark
 */
export const createHangarPlanVehicleMark = (
    hangarPlanId: MaybeRefOrGetter<string>,
    hangarPlanVehicleMarkCreateInput: MaybeRefOrGetter<HangarPlanVehicleMarkCreateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
hangarPlanVehicleMarkCreateInput = toValue(hangarPlanVehicleMarkCreateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/vehicle-marks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanVehicleMarkCreateInput, signal
    },
      );
    }




export const getCreateHangarPlanVehicleMarkMutationKey = () => ['createHangarPlanVehicleMark'] as const;

export const getCreateHangarPlanVehicleMarkMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanVehicleMark>>, TError,CreateHangarPlanVehicleMarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanVehicleMark>>, TError,CreateHangarPlanVehicleMarkMutationVariables, TContext> => {

const mutationKey = getCreateHangarPlanVehicleMarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarPlanVehicleMark>>, CreateHangarPlanVehicleMarkMutationVariables> = (props) => {
          const {hangarPlanId,data} = props ?? {};

          return  createHangarPlanVehicleMark(hangarPlanId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarPlanVehicleMarkMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarPlanVehicleMark>>>
    export type CreateHangarPlanVehicleMarkMutationBody = HangarPlanVehicleMarkCreateInput
    export type CreateHangarPlanVehicleMarkMutationError = ErrorType<ValidationError>
    export type CreateHangarPlanVehicleMarkMutationVariables = {hangarPlanId: string;data: HangarPlanVehicleMarkCreateInput}

    /**
 * @summary Create Hangar Plan Vehicle Mark
 */
export const useCreateHangarPlanVehicleMark = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarPlanVehicleMark>>, TError,CreateHangarPlanVehicleMarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarPlanVehicleMark>>,
        TError,
        CreateHangarPlanVehicleMarkMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarPlanVehicleMarkMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Hangar Plan Vehicle Mark
 */
export const updateHangarPlanVehicleMark = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    hangarPlanVehicleMarkUpdateInput: MaybeRefOrGetter<HangarPlanVehicleMarkUpdateInput>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);
hangarPlanVehicleMarkUpdateInput = toValue(hangarPlanVehicleMarkUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/vehicle-marks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanVehicleMarkUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanVehicleMarkMutationKey = () => ['updateHangarPlanVehicleMark'] as const;

export const getUpdateHangarPlanVehicleMarkMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>, TError,UpdateHangarPlanVehicleMarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>, TError,UpdateHangarPlanVehicleMarkMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanVehicleMarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>, UpdateHangarPlanVehicleMarkMutationVariables> = (props) => {
          const {hangarPlanId,id,data} = props ?? {};

          return  updateHangarPlanVehicleMark(hangarPlanId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanVehicleMarkMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>>
    export type UpdateHangarPlanVehicleMarkMutationBody = HangarPlanVehicleMarkUpdateInput
    export type UpdateHangarPlanVehicleMarkMutationError = ErrorType<ValidationError>
    export type UpdateHangarPlanVehicleMarkMutationVariables = {hangarPlanId: string;id: string;data: HangarPlanVehicleMarkUpdateInput}

    /**
 * @summary Update Hangar Plan Vehicle Mark
 */
export const useUpdateHangarPlanVehicleMark = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>, TError,UpdateHangarPlanVehicleMarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlanVehicleMark>>,
        TError,
        UpdateHangarPlanVehicleMarkMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanVehicleMarkMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan Vehicle Mark
 */
export const destroyHangarPlanVehicleMark = (
    hangarPlanId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      hangarPlanId = toValue(hangarPlanId);
id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${hangarPlanId}/vehicle-marks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanVehicleMarkMutationKey = () => ['destroyHangarPlanVehicleMark'] as const;

export const getDestroyHangarPlanVehicleMarkMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>, TError,DestroyHangarPlanVehicleMarkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>, TError,DestroyHangarPlanVehicleMarkMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanVehicleMarkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>, DestroyHangarPlanVehicleMarkMutationVariables> = (props) => {
          const {hangarPlanId,id} = props ?? {};

          return  destroyHangarPlanVehicleMark(hangarPlanId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanVehicleMarkMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>>

    export type DestroyHangarPlanVehicleMarkMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanVehicleMarkMutationVariables = {hangarPlanId: string;id: string}

    /**
 * @summary Destroy Hangar Plan Vehicle Mark
 */
export const useDestroyHangarPlanVehicleMark = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>, TError,DestroyHangarPlanVehicleMarkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlanVehicleMark>>,
        TError,
        DestroyHangarPlanVehicleMarkMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanVehicleMarkMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Plan
 */
export const hangarPlan = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${id}`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id
    ] as const;
    }


export const getHangarPlanQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlan>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlan>>> = ({ signal }) => hangarPlan(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlan>>, TError, TData>
}

export type HangarPlanQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlan>>>
export type HangarPlanQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Plan
 */

export function useHangarPlan<TData = Awaited<ReturnType<typeof hangarPlan>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlan>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Hangar Plan
 */
export const updateHangarPlan = (
    id: MaybeRefOrGetter<string>,
    hangarPlanUpdateInput: MaybeRefOrGetter<HangarPlanUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
hangarPlanUpdateInput = toValue(hangarPlanUpdateInput);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarPlanUpdateInput, signal
    },
      );
    }




export const getUpdateHangarPlanMutationKey = () => ['updateHangarPlan'] as const;

export const getUpdateHangarPlanMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlan>>, TError,UpdateHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlan>>, TError,UpdateHangarPlanMutationVariables, TContext> => {

const mutationKey = getUpdateHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarPlan>>, UpdateHangarPlanMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateHangarPlan(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarPlan>>>
    export type UpdateHangarPlanMutationBody = HangarPlanUpdateInput
    export type UpdateHangarPlanMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateHangarPlanMutationVariables = {id: string;data: HangarPlanUpdateInput}

    /**
 * @summary Update Hangar Plan
 */
export const useUpdateHangarPlan = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarPlan>>, TError,UpdateHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarPlan>>,
        TError,
        UpdateHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Hangar Plan
 */
export const destroyHangarPlan = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SuccessResponse>(
      {url: `/hangar/plans/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarPlanMutationKey = () => ['destroyHangarPlan'] as const;

export const getDestroyHangarPlanMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlan>>, TError,DestroyHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlan>>, TError,DestroyHangarPlanMutationVariables, TContext> => {

const mutationKey = getDestroyHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarPlan>>, DestroyHangarPlanMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyHangarPlan(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarPlan>>>

    export type DestroyHangarPlanMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarPlanMutationVariables = {id: string}

    /**
 * @summary Destroy Hangar Plan
 */
export const useDestroyHangarPlan = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarPlan>>, TError,DestroyHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarPlan>>,
        TError,
        DestroyHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Add Hangar Plan Purchases to the Wishlist
 */
export const addHangarPlanToWishlist = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanWishlistResult>(
      {url: `/hangar/plans/${id}/add-to-wishlist`, method: 'PUT', signal
    },
      );
    }




export const getAddHangarPlanToWishlistMutationKey = () => ['addHangarPlanToWishlist'] as const;

export const getAddHangarPlanToWishlistMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHangarPlanToWishlist>>, TError,AddHangarPlanToWishlistMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addHangarPlanToWishlist>>, TError,AddHangarPlanToWishlistMutationVariables, TContext> => {

const mutationKey = getAddHangarPlanToWishlistMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addHangarPlanToWishlist>>, AddHangarPlanToWishlistMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  addHangarPlanToWishlist(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddHangarPlanToWishlistMutationResult = NonNullable<Awaited<ReturnType<typeof addHangarPlanToWishlist>>>

    export type AddHangarPlanToWishlistMutationError = ErrorType<SchemaValidationErrorResponse>
    export type AddHangarPlanToWishlistMutationVariables = {id: string}

    /**
 * @summary Add Hangar Plan Purchases to the Wishlist
 */
export const useAddHangarPlanToWishlist = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addHangarPlanToWishlist>>, TError,AddHangarPlanToWishlistMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addHangarPlanToWishlist>>,
        TError,
        AddHangarPlanToWishlistMutationVariables,
        TContext
      > => {
      return useMutation(getAddHangarPlanToWishlistMutationOptions(options), queryClient);
    }
    /**
 * @summary Compare two Hangar Plans
 */
export const compareHangarPlans = (
    id: MaybeRefOrGetter<string>,
    otherId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);
otherId = toValue(otherId);

      return axiosClient<HangarPlanCompare>(
      {url: `/hangar/plans/${id}/compare/${otherId}`, method: 'GET', signal
    },
      );
    }




export const getCompareHangarPlansQueryKey = (id: MaybeRefOrGetter<string>,
    otherId: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'compare',otherId
    ] as const;
    }


export const getCompareHangarPlansQueryOptions = <TData = Awaited<ReturnType<typeof compareHangarPlans>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>,
    otherId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHangarPlans>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCompareHangarPlansQueryKey(id,otherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareHangarPlans>>> = ({ signal }) => compareHangarPlans(id,otherId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined && toValue(otherId) !== null && toValue(otherId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareHangarPlans>>, TError, TData>
}

export type CompareHangarPlansQueryResult = NonNullable<Awaited<ReturnType<typeof compareHangarPlans>>>
export type CompareHangarPlansQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Compare two Hangar Plans
 */

export function useCompareHangarPlans<TData = Awaited<ReturnType<typeof compareHangarPlans>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>,
    otherId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHangarPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareHangarPlansQueryOptions(id,otherId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Plan Comparison with the Hangar
 */
export const hangarPlanComparison = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanComparison>(
      {url: `/hangar/plans/${id}/comparison`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanComparisonQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'comparison'
    ] as const;
    }


export const getHangarPlanComparisonQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlanComparison>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanComparison>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanComparisonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlanComparison>>> = ({ signal }) => hangarPlanComparison(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlanComparison>>, TError, TData>
}

export type HangarPlanComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlanComparison>>>
export type HangarPlanComparisonQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hangar Plan Comparison with the Hangar
 */

export function useHangarPlanComparison<TData = Awaited<ReturnType<typeof hangarPlanComparison>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanComparison>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanComparisonQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Plan Drift
 */
export const hangarPlanDrift = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanDrift>(
      {url: `/hangar/plans/${id}/drift`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanDriftQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'drift'
    ] as const;
    }


export const getHangarPlanDriftQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlanDrift>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanDrift>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanDriftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlanDrift>>> = ({ signal }) => hangarPlanDrift(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlanDrift>>, TError, TData>
}

export type HangarPlanDriftQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlanDrift>>>
export type HangarPlanDriftQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hangar Plan Drift
 */

export function useHangarPlanDrift<TData = Awaited<ReturnType<typeof hangarPlanDrift>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanDrift>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanDriftQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Rebase Hangar Plan on the Hangar
 */
export const rebaseHangarPlan = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${id}/rebase`, method: 'PUT', signal
    },
      );
    }




export const getRebaseHangarPlanMutationKey = () => ['rebaseHangarPlan'] as const;

export const getRebaseHangarPlanMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebaseHangarPlan>>, TError,RebaseHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rebaseHangarPlan>>, TError,RebaseHangarPlanMutationVariables, TContext> => {

const mutationKey = getRebaseHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rebaseHangarPlan>>, RebaseHangarPlanMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  rebaseHangarPlan(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RebaseHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof rebaseHangarPlan>>>

    export type RebaseHangarPlanMutationError = ErrorType<SchemaValidationErrorResponse>
    export type RebaseHangarPlanMutationVariables = {id: string}

    /**
 * @summary Rebase Hangar Plan on the Hangar
 */
export const useRebaseHangarPlan = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebaseHangarPlan>>, TError,RebaseHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rebaseHangarPlan>>,
        TError,
        RebaseHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getRebaseHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Plan Resources
 */
export const hangarPlanResources = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanResources>(
      {url: `/hangar/plans/${id}/resources`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanResourcesQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'resources'
    ] as const;
    }


export const getHangarPlanResourcesQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlanResources>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanResources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanResourcesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlanResources>>> = ({ signal }) => hangarPlanResources(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlanResources>>, TError, TData>
}

export type HangarPlanResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlanResources>>>
export type HangarPlanResourcesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hangar Plan Resources
 */

export function useHangarPlanResources<TData = Awaited<ReturnType<typeof hangarPlanResources>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanResources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanResourcesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Share Hangar Plan
 */
export const shareHangarPlan = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${id}/share`, method: 'PUT', signal
    },
      );
    }




export const getShareHangarPlanMutationKey = () => ['shareHangarPlan'] as const;

export const getShareHangarPlanMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareHangarPlan>>, TError,ShareHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof shareHangarPlan>>, TError,ShareHangarPlanMutationVariables, TContext> => {

const mutationKey = getShareHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareHangarPlan>>, ShareHangarPlanMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  shareHangarPlan(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof shareHangarPlan>>>

    export type ShareHangarPlanMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ShareHangarPlanMutationVariables = {id: string}

    /**
 * @summary Share Hangar Plan
 */
export const useShareHangarPlan = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareHangarPlan>>, TError,ShareHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof shareHangarPlan>>,
        TError,
        ShareHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getShareHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Unshare Hangar Plan
 */
export const unshareHangarPlan = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlan>(
      {url: `/hangar/plans/${id}/share`, method: 'DELETE', signal
    },
      );
    }




export const getUnshareHangarPlanMutationKey = () => ['unshareHangarPlan'] as const;

export const getUnshareHangarPlanMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareHangarPlan>>, TError,UnshareHangarPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unshareHangarPlan>>, TError,UnshareHangarPlanMutationVariables, TContext> => {

const mutationKey = getUnshareHangarPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unshareHangarPlan>>, UnshareHangarPlanMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unshareHangarPlan(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnshareHangarPlanMutationResult = NonNullable<Awaited<ReturnType<typeof unshareHangarPlan>>>

    export type UnshareHangarPlanMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UnshareHangarPlanMutationVariables = {id: string}

    /**
 * @summary Unshare Hangar Plan
 */
export const useUnshareHangarPlan = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unshareHangarPlan>>, TError,UnshareHangarPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unshareHangarPlan>>,
        TError,
        UnshareHangarPlanMutationVariables,
        TContext
      > => {
      return useMutation(getUnshareHangarPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Plan Suggestions
 */
export const hangarPlanSuggestions = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanSuggestions>(
      {url: `/hangar/plans/${id}/suggestions`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanSuggestionsQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'suggestions'
    ] as const;
    }


export const getHangarPlanSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlanSuggestions>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSuggestions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanSuggestionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlanSuggestions>>> = ({ signal }) => hangarPlanSuggestions(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSuggestions>>, TError, TData>
}

export type HangarPlanSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlanSuggestions>>>
export type HangarPlanSuggestionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Hangar Plan Suggestions
 */

export function useHangarPlanSuggestions<TData = Awaited<ReturnType<typeof hangarPlanSuggestions>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSuggestions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanSuggestionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Plan Summary
 */
export const hangarPlanSummary = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<HangarPlanSummary>(
      {url: `/hangar/plans/${id}/summary`, method: 'GET', signal
    },
      );
    }




export const getHangarPlanSummaryQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','plans',id,'summary'
    ] as const;
    }


export const getHangarPlanSummaryQueryOptions = <TData = Awaited<ReturnType<typeof hangarPlanSummary>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPlanSummaryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPlanSummary>>> = ({ signal }) => hangarPlanSummary(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSummary>>, TError, TData>
}

export type HangarPlanSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPlanSummary>>>
export type HangarPlanSummaryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Plan Summary
 */

export function useHangarPlanSummary<TData = Awaited<ReturnType<typeof hangarPlanSummary>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPlanSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPlanSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






